module.exports = __webpack_public_path__ + "polaris@2x.78fe5012ba83d554949a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/iCheck/polaris/polaris@2x.png
// module id = 1251
// module chunks = 2